import { gql } from "@apollo/client"

export interface CreateOrganizationJoinRequestInput {
  toUser: string
  organization: string | number
  initialGroup?: string | number
  clientMutationId?: string
}

export const CREATE_ORGANIZATION_JOIN_REQUEST = gql`
  mutation createOrgJoinRequest($input: CreateOrganizationJoinRequestInput!) {
    createOrganizationJoinRequest(input: $input) {
      errors {
        field
        messages
      }
    }
  }
`
